/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTaskQueryResult } from '../../models/get-task-query-result';

export interface ApiTaskGetTaskGet$Plain$Params {
  Id?: string;
}

export function apiTaskGetTaskGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskGetTaskGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskGetTaskGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTaskQueryResult>;
    })
  );
}

apiTaskGetTaskGet$Plain.PATH = '/api/Task/GetTask';
